import { makeStyles } from '@material-ui/styles';
import MenuItem from '../CustomMessage/Actions/MenuItem';
import { Theme, Text, BlockUserLine } from '@bizzabo/design-system';

interface UnbanUserActionProps {
    onUnBanClicked: () => void;
}

const UnbanUserAction: React.FC<UnbanUserActionProps> = ({ onUnBanClicked }) => {
    const classes = useStyles();
    return (
        <MenuItem onClick={onUnBanClicked}>
            <div className={classes.icon}>
                <BlockUserLine />
            </div>
            <Text variant="t81" className={classes.name}>
                Unblock attendee
            </Text>
        </MenuItem>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        icon: { marginRight: 10, marginTop: 2, color: theme.palette.primary['600'] },
        name: { color: theme.palette.primary['600'] },
    }),
    {
        classNamePrefix: 'UnbanUserAction',
    }
);

export default UnbanUserAction;
